module.exports = __webpack_public_path__ + "media/images/countrysquared/ge-0c9410d80370ab659344696f11988216.svg";